import {
  BaSeButton,
  BaSeCheckbox,
  BaSeDialogContext,
  BaSeIcon,
  BaSeInput,
  BaSeLoadingSpinner,
  BaSeParagraph,
  BaSePopupButton,
  BaSeTheme,
  BaSeToggler,
} from '@base/react';

import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { Footer, FooterButton } from '../product/create-form-styled';
import { decode, encode } from 'html-entities';
import PageTemplate from './page-template';
import { CERTIFICADO_TEMPLATE, actionRequest } from '../../hooks/constants';
import { useUtilsService } from '../../hooks/utils';
import { ColorPicker } from 'mui-color';
import {
  ContentComposition,
  ContentTemplate,
  WrapperInput,
  WrapperInputColor,
  WrapperPageTemplate,
} from './template-certificados-styled';
import { WrapperDownloadFile } from '../certificados-em-lote/importar-certificados-styled';

const htmlModel =
  'https://storage.googleapis.com/chatbot-ead/ead/arquivos_uteis/html_padrao_template_certificado.html';

const TemplateCertificados = ({
  idTemplate,
  typeAction,
  save,
  update,
  returnToGrid,
  notify,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const [nameTamplate, setNameTamplate] = React.useState('');
  const [colorQrCode, setColorQrCode] = React.useState('');
  const [colorPick, setColorPick] = React.useState('');
  const [colorPickBackGround, setColorPickBackground] = React.useState('');
  const [colorBackgroundQrCode, setColorBackgroundQrCode] = React.useState('');
  const [isComposicaoConteudo, setIsComposicaoConteudo] = React.useState(false);
  const [isTransparent, setIsTransparent] = React.useState(false);
  const [isClear, setIsClear] = React.useState(false);
  const [maxItensComposition, setMaxItensComposition] = React.useState('');
  const [maxSizeItemComposition, setMaxSizeItemComposition] =
    React.useState('');
  const [pageTemplate, setPageTemplate] = React.useState({
    codeHtml: '',
    variables: null,
  });
  const [loading, setLoading] = React.useState(-1);
  const { showNotification } = React.useContext(BaSeDialogContext);
  const { isNotEmpty } = useUtilsService();
  const { backendGet } = Sebrae.useBackend();
  const { azulSebrae36, cinzaSebrae45 } = BaSeTheme.colors.institucionais;

  const isShow = React.useMemo(
    () => typeAction === actionRequest.show,
    [typeAction],
  );

  const isFillFields = React.useMemo(() => {
    const { update, show, newFromThis } = actionRequest;
    const actions = [update, show, newFromThis];
    return actions.includes(typeAction);
  }, [typeAction]);

  const clear = React.useCallback(() => {
    setNameTamplate('');
    setColorQrCode('');
    setColorBackgroundQrCode();
    setIsComposicaoConteudo(false);
    setIsTransparent(false);
    setIsComposicaoConteudo(false);
    setMaxItensComposition('');
    setMaxSizeItemComposition('');
    setIsClear(true);
    setPageTemplate({
      codeHtml: '',
      variables: null,
    });
    setLoading(-1);
  }, []);

  const formatJson = React.useCallback(
    (list) => list.reduce((obj, item) => ({ ...obj, ...item }), {}),
    [],
  );

  const handleActionRequest = React.useCallback(
    async (isShowTemplate, isCreateNew = false) => {
      const itemVariable = pageTemplate?.variables
        ? pageTemplate.variables.map((variable) => ({
            [variable.chave]: variable.valor,
          }))
        : null;

      const dtoTemplate = {
        corFundoQrCode: isTransparent ? null : colorBackgroundQrCode,
        corQrCode: colorQrCode,
        maxItensComposicao: isComposicaoConteudo
          ? parseInt(maxItensComposition)
          : null,
        maxTamanhoItemComposicao: isComposicaoConteudo
          ? parseInt(maxSizeItemComposition)
          : null,
        nome: nameTamplate,
        page: encode(pageTemplate.codeHtml),
        variaveis: itemVariable ? formatJson(itemVariable) : null,
        temItemComposicao: isComposicaoConteudo,
        fundoTransparenteQrCode: isTransparent,
      };
      setLoading(() => (isShowTemplate ? 2 : isCreateNew ? 1 : 0));

      const { sucess, message } =
        typeAction === 'update'
          ? await update(dtoTemplate)
          : await save(dtoTemplate);

      if (sucess) {
        setLoading(-1);
        notify({
          message: 'Dados salvos com sucesso!',
          color: 'confirmation',
        });
        clear();
        if (!isCreateNew) {
          returnToGrid();
        }
      } else {
        setLoading(-1);
        console.log('messsage', message);
        notify({
          message: 'Não foi possível salvar!',
          supportMessage: message ?? '',
          color: 'destructive',
        });
      }

      return;
    },
    [
      clear,
      colorBackgroundQrCode,
      colorQrCode,
      formatJson,
      isComposicaoConteudo,
      isTransparent,
      maxItensComposition,
      maxSizeItemComposition,
      nameTamplate,
      notify,
      pageTemplate,
      returnToGrid,
      save,
      typeAction,
      update,
    ],
  );

  const dataFile = React.useCallback(() => {
    const urlFile = htmlModel;
    setLoading(3);
    if (isNotEmpty(urlFile)) {
      const storageApi =
        'https://storage.googleapis.com/storage/v1/b/{{0}}/o/{{1}}';
      let urlMetadadoFinal;

      const bucket = urlFile.split('/')[3];
      const defaultBucketUrl = bucket + '/';
      const object = urlFile
        .substring(urlFile.indexOf(defaultBucketUrl))
        .replace(defaultBucketUrl, '');

      if (object) {
        urlMetadadoFinal = storageApi
          .replace('{{0}}', bucket)
          .replace('{{1}}', encodeURIComponent(object));

        fetch(urlMetadadoFinal)
          .then((resp) => resp.json())
          .then((json) => {
            const link = document.createElement('a');
            link.href = json.mediaLink;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            showNotification({
              message: `Download realizado com sucesso.`,
              color: 'confirmation',
            });
          })
          .catch((error) => {
            console.log('error:', error);
            showNotification({
              message: `Não foi possível realizar o download do modelo de certificado.`,
              color: 'destructive',
            });
          })
          .finally(() => setLoading(-1));
      }
    }
  }, [isNotEmpty, showNotification]);

  React.useEffect(() => {
    if (isFillFields) {
      setLoading(0);
      backendGet(`${CERTIFICADO_TEMPLATE}/${idTemplate}`)
        .then((data) => {
          const formatVariables = Object.entries(data.variaveis).map(
            ([chave, valor]) => ({ chave, valor }),
          );
          setNameTamplate(data?.nome ?? '');
          setColorQrCode(data?.corQrCode ?? '');
          setColorBackgroundQrCode(data?.corFundoQrCode ?? '');
          setColorPick(data?.corQrCode ?? '');
          setColorPickBackground(data?.corFundoQrCode ?? '');
          setMaxItensComposition(data?.maxItensComposicao ?? '');
          setMaxSizeItemComposition(data?.maxTamanhoItemComposicao ?? '');
          setIsTransparent(data?.fundoTransparenteQrCode ?? false);
          setIsComposicaoConteudo(data?.temItemComposicao ?? false);
          setPageTemplate({
            codeHtml: decode(data.page),
            variables: formatVariables,
          });
        })
        .catch((error) => {
          notify({
            message: error?.message ?? '',
            color: 'destructive',
          });
        })
        .finally(() => setLoading(-1));
    }
  }, [backendGet, idTemplate, isFillFields, isNotEmpty, notify]);

  return (
    <ContentTemplate>
      <div style={{ marginTop: '-48px' }}>
        {loading === 3 ? (
          <BaSeLoadingSpinner
            color="default"
            description="Carregando… Aguarde."
            diameter={40}
            type="tertiary"
          />
        ) : (
          <WrapperDownloadFile onClick={dataFile}>
            <BaSeIcon
              color={azulSebrae36}
              description="icon-download"
              name="file-download"
              size={17}
            />
            <BaSeParagraph color={azulSebrae36}>
              Baixe aqui o HTML com o modelo do certificado padrão
            </BaSeParagraph>
          </WrapperDownloadFile>
        )}
      </div>
      <BaSeInput
        isLoading={loading === 0}
        isDisabled={isShow}
        label="Nome do template"
        onChange={(e) => setNameTamplate(e.toUpperCase())}
        placeholder="Digite o nome do template"
        value={nameTamplate}
        width="404px"
      />
      <WrapperInput>
        <BaSeInput
          isLoading={loading === 0}
          isDisabled={isShow}
          label="Cor do QR Code"
          onChange={(e) => {
            setColorQrCode(e);
            setColorPick(e);
          }}
          value={colorQrCode}
          width="235px"
        />
        <WrapperInputColor isDisabled={isShow}>
          <ColorPicker
            onChange={(e) => {
              setColorQrCode(`#${e.hex}`);
              setColorPick(e);
            }}
            value={colorPick}
          />
        </WrapperInputColor>
      </WrapperInput>
      <WrapperInput>
        <BaSeInput
          isLoading={loading === 0}
          isDisabled={isTransparent || isShow}
          label="Cor de fundo do QR Code"
          onChange={(e) => {
            setColorBackgroundQrCode(e);
            setColorPickBackground(e);
          }}
          value={isTransparent ? 'Transparente' : colorBackgroundQrCode}
          width="235px"
        />
        <WrapperInputColor isDisabled={isShow}>
          <ColorPicker
            disableAlpha={isTransparent}
            onChange={(e) => {
              setColorBackgroundQrCode(`#${e.hex}`);
              setColorPickBackground(e);
            }}
            value={colorPickBackGround}
          />
        </WrapperInputColor>
        <div style={{ margin: 'auto 0 8px ' }}>
          <BaSeCheckbox
            disabled={isShow}
            align="center-left"
            color={azulSebrae36}
            label="Transparente"
            onChange={() => {
              setIsTransparent((transparent) => {
                if (!transparent) {
                  setColorPickBackground('#00000000');
                  setColorBackgroundQrCode('#00000000');
                }
                return !transparent;
              });
            }}
            shape="square"
            size="medium"
            checked={isTransparent}
          />
        </div>
      </WrapperInput>
      <ContentComposition>
        <div style={{ display: 'flex', gap: 4 }}>
          <BaSeParagraph color={cinzaSebrae45}>
            Habilitar composicaoConteudo
          </BaSeParagraph>
          <BaSePopupButton
            alertSize={300}
            iconProps={{
              color: azulSebrae36,
              name: undefined,
              size: 16,
            }}
            message="A composição de conteúdo serve para listar itens no formato número (1, 2, 3, etc). Essa funcionalidade é utilizada no Conteúdo Programático, por exemplo. A quantidade de itens e máximo de caracteres deverá ser definida para garantir que o template seja gerado corretamente."
            title="Habilitar"
          />
        </div>
        <BaSeToggler
          isDisabled={isShow}
          color="default"
          onChange={() =>
            setIsComposicaoConteudo((isComposition) => !isComposition)
          }
          type="outlined"
          value={isComposicaoConteudo}
        />
      </ContentComposition>
      {isComposicaoConteudo && (
        <ContentComposition>
          <BaSeInput
            isLoading={loading === 0}
            isDisabled={isShow}
            label="Número máximo de itens"
            onChange={(e) => setMaxItensComposition(e.replace(/\D/g, ''))}
            placeholder="Apenas número"
            value={maxItensComposition}
            width="294px"
          />
          <BaSeInput
            isLoading={loading === 0}
            isDisabled={isShow}
            label="Número máximo de caracteres por item"
            onChange={(e) => setMaxSizeItemComposition(e.replace(/\D/g, ''))}
            placeholder="Apenas número"
            value={maxSizeItemComposition}
            width="294px"
          />
        </ContentComposition>
      )}
      <WrapperPageTemplate>
        <PageTemplate
          pageTemplate={pageTemplate}
          setPageTemplate={setPageTemplate}
          setIsClear={setIsClear}
          isClear={isClear}
          isFillFields={isFillFields}
          typeAction={typeAction}
          dtoTemplate={{
            corFundoQrCode: isTransparent ? null : colorBackgroundQrCode,
            corQrCode: colorQrCode,
            fundoTransparenteQrCode: isTransparent,
            temItemComposicao: isComposicaoConteudo,
            maxItensComposicao: isComposicaoConteudo
              ? parseInt(maxItensComposition)
              : null,
            maxTamanhoItemComposicao: isComposicaoConteudo
              ? parseInt(maxSizeItemComposition)
              : null,
            nome: nameTamplate,
          }}
        />
      </WrapperPageTemplate>
      <Footer>
        {typeAction !== actionRequest.show && (
          <FooterButton>
            <BaSeButton
              isDisabled={loading === 1}
              isLoading={loading === 0}
              value="Salvar"
              onClick={() => handleActionRequest(false)}
            />
            <BaSeButton
              isLoading={loading === 1}
              isDisabled={loading === 0}
              type="secondary"
              value="Salvar e criar novo"
              color={azulSebrae36}
              onClick={() => handleActionRequest(false, true)}
            />
          </FooterButton>
        )}
        <BaSeButton
          type={isShow ? 'primary' : 'secondary'}
          color={azulSebrae36}
          value={isShow ? 'Voltar' : 'Cancelar'}
          onClick={() => {
            returnToGrid();
            clear();
          }}
        />
      </Footer>
    </ContentTemplate>
  );
};

export { TemplateCertificados as default };
